import React from 'react';
import './AboutMe.css';
import react from '../../../images/react.20adfb35.png';
import redux from '../../../images/redux.b3b939c6.png';
import js from '../../../images/js.dd493364.png';
import bootstrap from '../../../images/bootstrap.f132cb79.png';
import material from '../../../images/meta-ui.9482fda5.png';
import sass from '../../../images/sass.6d76b44e.png';
import firebase from '../../../images/firebase.a4156cb6.png';
import html from '../../../images/download.png';
import css from '../../../images/css.409b3a09.png';
import node from '../../../images/nodejs.aa8bc616.png';
import express from '../../../images/expressjs.bd60c4de.png';
import mongoDb from '../../../images/mongodb.a8889d62.png';
import heroku from '../../../images/download (1).png';
import vs from '../../../images/vs-code.54c2de39.png';
import git from '../../../images/download (2).png';
import github from '../../../images/download (3).png';
import netlify from '../../../images/netlify.603ef81c.png';
import npm from '../../../images/npm.bf117b29.png';
import cdt from '../../../images/cdt.136d030e.png';

const frontEnd = [
    {
        name: 'React',
        img: react
    },
    {
        name: 'Redux',
        img: redux
    },
    {
        name: 'JavaScript',
        img: js
    },
    {
        name: 'Bootstrap',
        img: bootstrap
    },
    {
        name: 'Material-UI',
        img: material
    },
    {
        name: 'Sass',
        img: sass
    },
    {
        name: 'Firebase',
        img: firebase
    },
    {
        name: 'HTML',
        img: html
    },
    {
        name: 'CSS',
        img: css
    }
];

const backEnd = [
    {
        name: 'Node.Js',
        img: node
    },
    {
        name: 'Express.Js',
        img: express
    },
    {
        name: 'MongoDB',
        img: mongoDb
    },
    {
        name: 'Heroku',
        img: heroku
    }
];

const tools = [
    {
        name: 'Visual Studio Code',
        img: vs
    },
    {
        name: 'Git',
        img: git
    },
    {
        name: 'GitHub',
        img: github
    },
    {
        name: 'Netlify',
        img: netlify
    },
    {
        name: 'npm',
        img: npm
    },
    {
        name: 'Chrome Dev Tools',
        img: cdt
    }
];

const personalInfosOne = [
    {
        title: 'Name',
        value: 'Masum Billa'
    },
    {
        title: 'City',
        value: 'Dhaka'
    },
    {
        title: 'Country',
        value: 'Bangladesh'
    },
    {
        title: 'Freelance',
        value: 'Available'
    }
];

const personalInfosTwo = [
    {
        title: 'Email',
        value: 'masumiraj0218@gmail.com'
    },
    {
        title: 'Skype',
        value: 'masumbilla'
    },
    {
        title: 'Linked In',
        value: 'masum billa'
    },
    {
        title: 'Language',
        value: 'Bangla, English, Hindi'
    },
];

const success = [
    {
        number: 1,
        titleOne: 'years of',
        titleTwo: 'experience'
    },
    {
        number: 22,
        titleOne: 'completed',
        titleTwo: 'project'
    },
    {
        number: 10,
        titleOne: 'happy',
        titleTwo: 'customers'
    },
    {
        number: 5,
        titleOne: 'blogs',
        titleTwo: 'written'
    }
];

const AboutMe = () => {
    return (
        <div className="container aboutMe-area mt-5 pt-5">
            <h3 className="Title mt-5">About me</h3>

            <div className="about-area row my-5">
                <div className="col-md-6">
                    <h4 className="pt-3 personalInfos">Personal Infos</h4>
                    <div className="row mt-5">
                        <div className="col-md-6">
                            {
                                personalInfosOne.map(item => 
                                    <p className="py-2">
                                        <span className="title pr-2">{item.title}:</span>
                                        <span className="value">{item.value}</span>
                                    </p>
                                )
                            }
                        </div>

                        <div className="col-md-6">
                            {
                                personalInfosTwo.map(item => 
                                    <p className="py-2">
                                        <span className="title pr-2">{item.title}:</span>
                                        <span className="value">{item.value}</span>
                                    </p>
                                )
                            }
                        </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="row mx-auto">
                        {
                            success.map(item =>
                                <div className="col-md-6">
                                    <div className="skills my-3">
                                        <h3><span className="number">{item.number}</span><sup>+</sup></h3>
                                        <p className="open-sans-font m-0 position-relative text-uppercase">{item.titleOne} <span className="d-block">{item.titleTwo}</span></p>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>

            <div>
                <h4 className="sub-title">My Skills</h4>

                <div className="mt-5">
                    <h5 className="ml-5">Front-End Technologies:</h5>

                    <div className="d-flex flex-wrap my-4 ml-5 pl-5">
                        {
                            frontEnd.map(item => 
                                <div className="technology text-center p-3 text-center mr-4">
                                    <img className="img-fluid" src={item.img} alt=""/>
                                    <figcaption>{item.name}</figcaption>
                                </div>
                            )
                        }
                    </div>
                </div>
            
                <div>
                    <h5 className="ml-5">Back-End Technologies:</h5>

                    <div className="d-flex flex-wrap my-4 ml-5 pl-5">
                        {
                            backEnd.map(item => 
                                <div className="technology text-center p-3 text-center mr-4">
                                    <img className="img-fluid" src={item.img} alt=""/>
                                    <figcaption>{item.name}</figcaption>
                                </div>
                            )
                        }
                    </div>
                </div>

                <div>
                    <h5 className="ml-5">Tools:</h5>

                    <div className="d-flex flex-wrap my-4 ml-5 pl-5">
                        {
                            tools.map(item => 
                                <div className="technology text-center p-3 text-center mr-4">
                                    <img className="img-fluid" src={item.img} alt=""/>
                                    <figcaption>{item.name}</figcaption>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>

            <div className="educationAndExperience my-5">
                <div className="row">
                    <div className="col-md-6 mb-3">
                        <h4 className="sub-title">Education</h4>

                        <div className="mt-3">
                            <h5>B.Sc In Computer Science And Engineering</h5>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <h4 className="sub-title">Experience</h4>

                        <div className="mt-3">
                            Coming Soon...
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutMe;